import { Millisecond } from "@constants/time";
export const SearchDebounceTime = Millisecond * 500;
